webpackJsonp([6],{

/***/ "./src/components/GuideSidebar.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.constructTree = exports.fixPath = exports.sidebarFragment = undefined;
	
	var _container, _extends2;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__("./src/components/Link.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var GuideSidebar = function GuideSidebar(_ref) {
	  var props = _ref.props,
	      current = _ref.current,
	      root = _ref.root,
	      search = _ref.search;
	  return Glamor.createElement(
	    'div',
	    { css: styles.container },
	    Glamor.createElement(
	      'div',
	      { css: styles.contents },
	      Glamor.createElement(
	        _Link2.default,
	        { css: [styles.link, { display: 'flex' }], to: search },
	        'Search',
	        Glamor.createElement(
	          'svg',
	          { css: styles.searchIcon, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 15 15' },
	          Glamor.createElement('path', { fill: _colors.text, d: 'M6.213 12.548C2.783 12.548 0 9.738 0 6.274 0 2.81 2.782 0 6.213 0c3.432 0 6.214 2.81 6.214 6.274 0 1.358-.428 2.616-1.154 3.643L15 13.482 13.576 15l-3.77-3.606c-1.015.727-2.254 1.154-3.593 1.154zm0-2.09c2.288 0 4.143-1.874 4.143-4.184S8.5 2.09 6.213 2.09c-2.287 0-4.142 1.874-4.142 4.184s1.856 4.183 4.143 4.183z' })
	        )
	      ),
	      Glamor.createElement(Node, { current: current, item: root, root: true, depth: 0 })
	    )
	  );
	};
	
	var Node = function Node(_ref2) {
	  var current = _ref2.current,
	      root = _ref2.root,
	      _ref2$item = _ref2.item,
	      title = _ref2$item.title,
	      relativePath = _ref2$item.relativePath,
	      children = _ref2$item.children,
	      depth = _ref2.depth;
	
	  var linkStyles = [styles.link, styles['link' + depth], relativePath === current && styles.currentLink];
	  return children.length ? Glamor.createElement(
	    'div',
	    { css: [styles.node, root && styles.rootNode] },
	    !root ? Glamor.createElement(
	      _Link2.default,
	      { to: relativePath, css: linkStyles },
	      title
	    ) : null,
	    Glamor.createElement(
	      'ul',
	      { css: [styles.children, root && styles.rootChildren] },
	      children.map(function (child) {
	        return Glamor.createElement(
	          'li',
	          { style: styles.li, key: child.relativePath },
	          Glamor.createElement(Node, { current: current, item: child, depth: depth + 1 })
	        );
	      })
	    )
	  ) : Glamor.createElement(
	    _Link2.default,
	    { css: [styles.node, linkStyles], to: relativePath },
	    title
	  );
	};
	
	exports.default = GuideSidebar;
	var sidebarFragment = exports.sidebarFragment = '** extracted graphql fragment **';
	
	var phablet = '@media(max-width: 800px)';
	
	var styles = {
	  container: (_container = {
	    width: (0, _typography.rhythm)(8),
	    minHeight: '100%',
	    padding: '20px'
	  }, _defineProperty(_container, phablet, _extends({}, (0, _typography.scale)(0), {
	    width: 'auto'
	  })), _defineProperty(_container, 'fontFamily', (0, _typography.headerFontFamily)()), _defineProperty(_container, 'background', _colors.gray), _container),
	
	  contents: {
	    padding: (0, _typography.rhythm)(1 / 3) + ' ' + (0, _typography.rhythm)(1 / 2)
	  },
	
	  node: {},
	
	  li: {
	    margin: 0,
	    padding: 0
	  },
	
	  link: _extends({
	    textDecoration: 'none',
	    color: 'currentColor'
	  }, (0, _typography.scale)(-0.2), (_extends2 = {}, _defineProperty(_extends2, phablet, {
	    padding: '' + (0, _typography.rhythm)(1 / 4)
	  }), _defineProperty(_extends2, 'display', 'block'), _defineProperty(_extends2, ':hover', {
	    color: _colors.accent
	  }), _extends2)),
	
	  currentLink: {
	    textDecoration: 'underline',
	    textDecorationColor: _colors.accent,
	    color: _colors.accent
	  },
	
	  link1: {
	    fontWeight: 'bold',
	    marginTop: '1em',
	    marginBottom: '.25em'
	  },
	
	  children: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    paddingLeft: (0, _typography.rhythm)(1 / 3),
	    marginLeft: 0
	  },
	
	  rootChildren: {
	    borderLeft: 'none',
	    marginLeft: 0,
	    paddingLeft: 0
	  },
	
	  searchIcon: {
	    width: '15px',
	    height: '15px',
	    marginLeft: 'auto',
	    alignSelf: 'center'
	  }
	};
	
	var fixPath = exports.fixPath = function fixPath(relativePath) {
	  if (relativePath.match(/\/index\.md$/)) {
	    return '/' + relativePath.slice(0, -'/index.md'.length);
	  }
	  return '/' + relativePath.slice(0, -'.md'.length);
	};
	
	var parseData = function parseData(nodes) {
	  return nodes.map(function (_ref3) {
	    var relativePath = _ref3.relativePath,
	        _ref3$childMarkdownRe = _ref3.childMarkdownRemark.frontmatter,
	        title = _ref3$childMarkdownRe.title,
	        order = _ref3$childMarkdownRe.order;
	    return { relativePath: fixPath(relativePath), title: title, order: order };
	  });
	};
	
	var values = function values(obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var listify = function listify(node) {
	  return _extends({}, node, {
	    children: values(node.children).sort(function (a, b) {
	      return a.order - b.order;
	    }).map(listify)
	  });
	};
	
	var constructTree = exports.constructTree = function constructTree(section, files) {
	  var tree = { children: {} };
	  parseData(files).forEach(function (_ref4) {
	    var relativePath = _ref4.relativePath,
	        title = _ref4.title,
	        order = _ref4.order;
	
	    var parts = relativePath.split(/\//g).slice(1);
	    var last = parts.pop();
	    var parent = tree;
	    parts.forEach(function (part) {
	      if (!parent.children[part]) parent.children[part] = { children: {} };
	      parent = parent.children[part];
	    });
	    parent.children[last] = _extends({
	      children: {}
	    }, parent.children[last], {
	      relativePath: relativePath,
	      title: title,
	      order: order
	    });
	  });
	
	  var sectionPath = section.split('/');
	  var treeToListify = sectionPath.reduce(function (acc, section, i) {
	    return i === sectionPath.length - 1 ? acc[section] : acc[section].children;
	  }, tree.children);
	
	  return listify(treeToListify);
	};
	
	// TODO
	// export const query =
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"add-module-exports\",\"add-module-exports\",\"transform-object-assign\",[\"transform-react-jsx\",{\"pragma\":\"Glamor.createElement\"}],\"babel-plugin-glamor\"],\"presets\":[\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-env/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/chenglou/Github/reasonml.github.io/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/templates/Search.js":
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Section = __webpack_require__("./src/components/Section.js");
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _GuideSidebar = __webpack_require__("./src/components/GuideSidebar.js");
	
	var _GuideSidebar2 = _interopRequireDefault(_GuideSidebar);
	
	var _colors = __webpack_require__("./src/utils/colors.js");
	
	var _typography = __webpack_require__("./src/utils/typography.js");
	
	var _debounce = __webpack_require__("./src/utils/debounce.js");
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _Link = __webpack_require__("./src/components/Link.js");
	
	var _Link2 = _interopRequireDefault(_Link);
	
	var _Header = __webpack_require__("./src/components/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var walk = function walk(node, fn) {
	  [].forEach.call(node.childNodes, function (child) {
	    var res = fn(child);
	    if (res) {
	      node.replaceChild(res, child);
	    } else {
	      walk(child, fn);
	    }
	  });
	};
	
	var highlightContents = function highlightContents(node, needle) {
	  walk(node, function (child) {
	    if (child.nodeName === '#text') {
	      if (child.nodeValue.match(needle)) {
	        var _node = document.createElement('span');
	        _node.innerHTML = child.nodeValue.replace(needle, function (v) {
	          return '<span class="search-highlighted-result">' + v + '</span>';
	        });
	        return _node;
	      }
	    }
	  });
	};
	
	var highlight = function highlight(html, needle) {
	  var tmp = document.createElement('div');
	  tmp.innerHTML = html;
	  var matching = [null];
	  ;[].forEach.call(tmp.childNodes, function (node) {
	    if (node.textContent.match(needle)) {
	      highlightContents(node, needle);
	      matching.push(node.outerHTML);
	    } else if (matching[matching.length - 1] !== null) {
	      matching.push(null);
	    }
	  });
	  if (matching[0] === null) matching.shift();
	  if (matching[matching.length - 1] === null) matching.pop();
	  return matching.map(function (m) {
	    return m === null ? '<p class="search-elided-section">...</p>' : m;
	  }).join('\n');
	};
	
	var search = function search(edges, needle) {
	  var rx = new RegExp(needle, 'ig');
	  return edges.filter(function (_ref) {
	    var _ref$node$childMarkdo = _ref.node.childMarkdownRemark,
	        html = _ref$node$childMarkdo.html,
	        title = _ref$node$childMarkdo.frontmatter.title;
	
	    if (title.match(rx) || html.match(rx)) {
	      return true;
	    }
	  }).map(function (_ref2) {
	    var _ref2$node = _ref2.node,
	        relativePath = _ref2$node.relativePath,
	        _ref2$node$childMarkd = _ref2$node.childMarkdownRemark,
	        html = _ref2$node$childMarkd.html,
	        title = _ref2$node$childMarkd.frontmatter.title;
	
	    return {
	      relativePath: relativePath,
	      html: highlight(html, needle),
	      // html: html.replace(rx, v => '<span style="font-weight: bold; background-color: red">' + v + '</span>'),
	      title: title // TODO highlight cleverly, probably use the markdown
	      // source instead
	    };
	  });
	};
	
	var Search = function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  function Search(props) {
	    _classCallCheck(this, Search);
	
	    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this));
	
	    _initialiseProps.call(_this);
	
	    var text = decodeURIComponent(props.location.search.slice(1));
	    _this.state = {
	      results: text.trim().length > 2 ? search(props.data.allFile.edges, text.toLowerCase()) : [],
	      searchText: text
	    };
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.input.focus();
	    }
	  }, {
	    key: "renderMain",
	    value: function renderMain() {
	      var _this2 = this;
	
	      return Glamor.createElement(
	        "div",
	        { css: styles.container },
	        Glamor.createElement(
	          "div",
	          { css: styles.searchBar },
	          "Search",
	          Glamor.createElement("input", {
	            ref: function ref(input) {
	              return _this2.input = input;
	            },
	            css: styles.searchInput,
	            onChange: function onChange(e) {
	              return _this2.setText(e.target.value);
	            },
	            value: this.state.searchText,
	            type: "text"
	          })
	        ),
	        Glamor.createElement(
	          "div",
	          { css: styles.results },
	          this.state.results.slice(0, 10).map(function (result) {
	            return Glamor.createElement(
	              "div",
	              { key: result.relativePath, css: styles.result },
	              Glamor.createElement(
	                "h4",
	                { css: styles.resultTitleWrapper },
	                Glamor.createElement(
	                  _Link2.default,
	                  { css: styles.resultTitle, to: (0, _GuideSidebar.fixPath)(result.relativePath) },
	                  "\u2023 ",
	                  result.title
	                )
	              ),
	              Glamor.createElement("div", {
	                css: styles.resultBody,
	                dangerouslySetInnerHTML: { __html: result.html }
	              })
	            );
	          })
	        )
	      );
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$pathContext = this.props.pathContext,
	          section = _props$pathContext.section,
	          sectionTitle = _props$pathContext.sectionTitle;
	      var allFile = this.props.data.allFile;
	
	      return Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(_reactHelmet2.default, { title: sectionTitle + " Search" }),
	        Glamor.createElement(
	          _Section2.default,
	          { backgroundColor: _colors.accent, css: { color: 'white' } },
	          Glamor.createElement(_Header2.default, { inverted: true }),
	          Glamor.createElement(
	            "div",
	            { css: { alignItems: 'center' } },
	            Glamor.createElement(
	              "h1",
	              null,
	              Glamor.createElement(
	                _Link2.default,
	                { css: styles.topLink, to: "/" + section },
	                sectionTitle
	              )
	            )
	          )
	        ),
	        Glamor.createElement(
	          _Section2.default,
	          { css: styles.contentSection },
	          Glamor.createElement(
	            "div",
	            { css: styles.sidebar },
	            Glamor.createElement(_GuideSidebar2.default, {
	              current: section + "/search",
	              search: "/" + section + "/search",
	              root: (0, _GuideSidebar.constructTree)(section, allFile.edges.map(function (edge) {
	                return edge.node;
	              }))
	            })
	          ),
	          this.renderMain()
	        )
	      );
	    }
	  }]);
	
	  return Search;
	}(_react2.default.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.search = (0, _debounce2.default)(function (edges, text) {
	    _this3.setState({
	      results: search(edges, text)
	    });
	  }, 200, true);
	
	  this.setText = function (text) {
	    var shouldSearch = text.trim().length > 2;
	    var results = shouldSearch ? {} : { results: [] };
	    window.history.replaceState({}, document.title, window.location.pathname + '?' + text);
	
	    _this3.setState(_extends({
	      searchText: text
	    }, results));
	
	    if (shouldSearch) {
	      _this3.search(_this3.props.data.allFile.edges, text.toLowerCase());
	    }
	  };
	};
	
	exports.default = Search;
	
	
	var styles = {
	  container: {
	    flex: 1,
	    flexShrink: 1
	  },
	  editLink: {
	    fontSize: '14px',
	    fontWeight: 'normal',
	    lineHeight: '25px'
	  },
	  title: {
	    borderBottom: '1px solid ' + _colors.dividerLine,
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-between',
	    alignItems: 'flex-end'
	  },
	  contentSection: {
	    flexDirection: 'row',
	    '@media(max-width: 800px)': {
	      flexDirection: 'column-reverse'
	    }
	  },
	  sidebar: {
	    // padding: '2em',
	  },
	  main: {
	    position: 'relative',
	    flex: 1,
	    padding: '2em',
	    minWidth: 0
	  },
	
	  searchBar: {
	    flexDirection: 'row',
	    alignItems: 'center',
	    padding: 10
	  },
	
	  searchInput: {
	    flex: 1,
	    padding: '5px 10px',
	    fontSize: 18,
	    marginLeft: 10
	  },
	
	  results: {
	    padding: 10
	  },
	
	  result: {},
	
	  resultTitle: {
	    fontWeight: 'bold'
	  },
	
	  resultTitleWrapper: {
	    marginBottom: (0, _typography.rhythm)(0.5)
	  },
	
	  resultBody: {
	    fontSize: 12,
	    paddingLeft: 20,
	    '& .search-highlighted-result': {
	      backgroundColor: 'gold',
	      fontWeight: 'bold'
	    },
	    '& p': {
	      marginBottom: 10
	    },
	    '& .search-elided-section': {
	      color: '#aaa',
	      height: 5,
	      marginBottom: 15,
	      marginTop: -10
	    },
	    '& ul': {
	      marginBottom: 5
	    },
	    '& code': {
	      fontSize: 'inherit'
	    }
	  }
	
	};
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/glamor-react/lib/index.js")))

/***/ }),

/***/ "./src/utils/debounce.js":
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function (func, wait, immediate) {
		var timeout = void 0;
		return function () {
			var context = this,
			    args = arguments;
			var later = function later() {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-templates-search-js-ebdf343b0d2ef63fcf09.js